/**
 * @file schemas.ts
 * @brief Zod schemas for Super Admin → Enterprise inquiries.
 *
 * @details
 * Mirrors GET/PATCH `/api/admin/enterprise-inquiries` from mobile Plans
 * contact-sales form (ADR-020).
 *
 * @author DES
 * @date 26-07-2026
 */

import { z } from "zod";

export const EnterpriseInquiryStatusSchema = z.enum([
  "new",
  "contacted",
  "closed",
]);
export type EnterpriseInquiryStatus = z.infer<
  typeof EnterpriseInquiryStatusSchema
>;

export const EnterpriseInquiryIntentSchema = z.enum(["new", "change_plan"]);
export type EnterpriseInquiryIntent = z.infer<
  typeof EnterpriseInquiryIntentSchema
>;

export const EnterpriseInquirySchema = z.object({
  id: z.string().uuid(),
  user_id: z.string().uuid().nullable().optional(),
  company_id: z.string().uuid().nullable().optional(),
  contact_name: z.string(),
  contact_email: z.string(),
  contact_phone: z.string(),
  seats_required: z.coerce.number().int(),
  message: z.string().nullable().optional(),
  status: EnterpriseInquiryStatusSchema,
  intent: EnterpriseInquiryIntentSchema.optional().default("new"),
  created_at: z.string(),
  updated_at: z.string().optional().nullable(),
  company_name: z.string().nullable().optional(),
  user_email: z.string().nullable().optional(),
  user_first_name: z.string().nullable().optional(),
  user_last_name: z.string().nullable().optional(),
});
export type EnterpriseInquiry = z.infer<typeof EnterpriseInquirySchema>;

export const EnterpriseInquiryListResponseSchema = z.object({
  success: z.boolean().optional(),
  items: z.array(EnterpriseInquirySchema),
  page: z.coerce.number(),
  pageSize: z.coerce.number(),
  total: z.coerce.number(),
  hasMore: z.boolean().optional(),
});
export type EnterpriseInquiryListResponse = z.infer<
  typeof EnterpriseInquiryListResponseSchema
>;

export type EnterpriseInquiryListParams = {
  page?: number;
  pageSize?: number;
  search?: string;
  status?: EnterpriseInquiryStatus | "";
};
